import { Link } from "react-router-dom";
import { testIds } from "@/constants/testIds/b2b";

const RETAIL_URL = "https://rowenkidsclub.com";

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-border bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-muted-foreground">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <span>© {new Date().getFullYear()} Rowen Kids Club</span>
          <Link to="/shop" className="hover:text-foreground" data-testid="footer-link-shop">Products</Link>
          <Link to="/register" className="hover:text-foreground" data-testid="footer-link-register">Apply</Link>
          <Link to="/login" className="hover:text-foreground" data-testid="footer-link-login">Sign in</Link>
        </div>
        <div className="flex items-center gap-4">
          <a href="mailto:hello@rowenkidsclub.com" className="hover:text-foreground">hello@rowenkidsclub.com</a>
          <span aria-hidden="true">·</span>
          <a
            href={RETAIL_URL}
            target="_blank"
            rel="noreferrer"
            data-testid={testIds.footerShopRetail}
            className="hover:text-foreground"
          >
            Shop Retail →
          </a>
        </div>
      </div>
    </footer>
  );
}
